module.exports = __webpack_public_path__ + "static/media/okullar@2x.07d7f114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/okullar@2x.png
// module id = 52
// module chunks = 0